module.exports = __webpack_public_path__ + "img/login1.118c8972.png";